import css from "styled-jsx/css";
import Colors from "/styles/colors";

const TAG_IMAGE_SIZE = "44px";

export const componentStyles = css.global`
  .tag {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    cursor: default;

    .tag-image-wrapper {
      background-color: #eef2ff;
      display: flex;
      align-items: center;
      justify-content: center;
      height: ${TAG_IMAGE_SIZE};
      width: ${TAG_IMAGE_SIZE};
      border-radius: 50%;

      .tag-picture {
        height: ${TAG_IMAGE_SIZE};
        .tag-icon {
          height: 100%;
        }
      }
    }

    .tag-text {
      margin-left: 8px;
      font-size: 20px;
      line-height: 22px;
      color: ${Colors.mud};
      font-weight: 300;
    }
  }
`;
